<div class="col-12 p-0">
  <form class="">
    <div class="cmn-warningalert-popup-container">
      <div class="cmn-modal-header">
        <h4 class="modal-header-title"><img src="../../../../assets/img/addclient/warningIcon.svg" /> Warning</h4>
      </div>
      <div class="cmn-modal-content">
        <p>
          {{warnmsgcontact}}
        </p>
        <p *ngIf="_flagForline2">{{warnAlertmsgcontact}}</p>
      </div>
      <div class="cmn-modal-footer">
        <button type="button" mat-button (click)="closeno()" class="cmn-inverse-btn mr-3" data-testid="btn-warning-no">No</button>
        <button type="button" mat-button class="cmn-blue-btn" (click)="closeyes()" data-testid="btn-warning-yes">Yes</button>
      </div>
    </div>
  </form>
</div>

